// A quiet, static launch-date panel — replaces the countdown clock.
// Same section framing as before, but no ticking; editorial voice throughout.

export default function LaunchNote() {
  return (
    <section data-testid="launch-note" className="relative py-24 md:py-32">
      <div className="max-w-[1200px] mx-auto px-6 md:px-10">
        <div className="grid md:grid-cols-12 gap-10 items-end">
          <div className="md:col-span-8">
            <div className="mono text-[11px] tracking-[0.28em] uppercase text-[#4A7C7B] mb-4">Book One</div>
            <h2 className="serif text-[clamp(2.25rem,5.5vw,4.5rem)] leading-[1.02] tracking-tight text-espresso">
              Book One arrives <span className="italic text-[#4A7C7B]">November 15, 2026.</span>
            </h2>
            <p className="mt-6 max-w-lg text-charcoal/90 leading-relaxed">
              A quiet note will find you when it's ready.
            </p>
          </div>
          <div className="md:col-span-4 md:text-right">
            <span className="mono text-[11px] tracking-[0.28em] uppercase text-espresso/80 border border-black/15 rounded-full px-4 py-2">
              Coming November 2026
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}
